import { useEffect, useState } from 'react'
import { Guild } from '../components/AppGuild'
import { GuildCardLoader } from '../components/GuildCardLoader'
import { AppHeader } from "../components/AppHeader";
import { fetchGuilds, fetchUser } from '../api'
import { message } from 'antd';
import { login } from '../api'
import { useTranslation } from "react-i18next"
import botconfig from '../botconfig';
export function ServersPage() {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(true);
  const [guilds, setGuilds] = useState([])
  const [messageApi, contextHolder] = message.useMessage()
  function errorMessage(error) {
    if (error) console.error(error)
    messageApi.open({
      type: 'error',
      content: t('Произошла ошибка :('),
    });
  }
  useEffect(() => {
    document.title = `WETBOT | Мои серверы`
    async function fetchData() {
      let user
      let localItem = JSON.parse(localStorage.getItem("wetbot"))
      if (!localItem?.token) return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
      if (localItem.token.expires_at <= Date.now()) {
          localStorage.removeItem("wetbot")
          return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
      } else {
        try {
          user = await fetchUser(localItem.token)
        } catch (err) {
            localStorage.removeItem("wetbot")
            return window.location.replace(`${botconfig.root_path}${botconfig.website_port}/login`)
        }
      }
      try {
        const responseGuilds = await fetchGuilds(user.id, localItem.token.access_token)
        setGuilds(responseGuilds)
      } catch (err) {
        errorMessage(err)
      }
      setLoading(false)
    }
    fetchData()
  }, [])
  if (loading) {
    return (
      <>
        {contextHolder}
        <AppHeader></AppHeader>
        <div className="guilds_container">
          <GuildCardLoader />
        </div>
      </>
    )
  }
  return (
    <>
      {contextHolder}
      <AppHeader></AppHeader>
      <div className="guilds_container">
        {guilds.map(element => element.permissions.find(e => e === "Administrator" || e === "ManageGuild") || element.added ? <Guild guild={element} key={element.id} /> : undefined)}
      </div>
    </>
  )
}